exports.regularity_one = {
'子zi3': [ '子', '仔', '籽' ],
'㝵de2': [ '得', '锝', '鍀' ],
'里li3': [ '里', '理', '哩', '鲤', '鯉', '俚', '娌', '悝', '锂', '鋰' ],
'麻ma2': [ '麼', '麻' ],
'禾he2': [ '和', '禾', '龢' ],
'生sheng1': [ '生', '牲', '甥', '笙' ],
'而er2': [ '而', '鸸', '鴯' ],
'心xin1': [ '心', '芯' ],
'面mian4': [ '面', '麵' ],
'多duo1': [ '多', '哆' ],
'无wu2': [ '无', '芜', '庑' ],
'老lao3': [ '老', '姥', '佬', '铑', '銠', '栳' ],
'旦dan4': [ '但', '担' ],
'见jian4': [ '见', '舰' ],
'见xian4': [ '见', '现', '苋', '岘' ],
'見xian4': [ '見', '現', '莧', '峴' ],
'长chang2': [ '长', '苌' ],
'长zhang3': [ '长', '涨' ],
'長chang2': [ '長', '萇' ],
'長zhang3': [ '長', '漲' ],
'从cong2': [ '从', '從', '丛' ],
'从cong1': [ '从', '從', '枞', '樅', '苁', '蓯' ],
'从zong4': [ '从', '從', '纵', '縱' ],
'方fang1': [ '方', '芳', '坊', '钫', '鈁', '枋' ],
'儿er2': [ '儿', '兒' ],
'回hui2': [ '回', '迴', '蛔', '茴', '洄' ],
'十shi2': [ '十', '實' ],
'巠jing1': [ '經', '莖', '涇' ],
'行hang2': [ '行', '桁' ],
'行xing4': [ '行', '荇' ],
'中zhong4': [ '种', '仲' ],
'日ri4': [ '日', '鈤' ],
'女nu:3': [ '女', '钕', '釹' ],
'女ru3': [ '女', '汝' ],
'二er4': [ '二', '贰', '貳' ],
'气qi4': [ '气', '氣', '汽' ],
'力li4': [ '力', '历', '励', '勵', '雳', '沥', '枥', '呖', '苈', '疬' ],
'门men2': [ '门', '扪', '钔' ],
'門men2': [ '門', '捫', '鍆' ],
'高gao1': [ '高', '篙' ],
'几ji1': [ '几', '机', '玑', '饥', '肌', '讥', '叽', '矶' ],
'几ji3': [ '几', '麂', '虮' ],
'丶zhu3': [ '主', '拄', '麈' ],
'山shan1': [ '山', '舢' ],
'占zhan4': [ '战', '站' ],
'文wen2': [ '文', '纹', '紋', '雯', '蚊', '玟' ],
'西xi1': [ '西', '牺', '茜', '硒', '粞' ],
'象xiang4': [ '像', '橡' ],
'幾ji1': [ '機', '璣', '饑', '譏', '嘰', '磯' ],
'王wang4': [ '王', '望', '旺' ],
'月yue4': [ '月', '钥', '刖' ],
'马ma3': [ '马', '吗', '玛', '码', '蚂', '犸' ],
'馬ma3': [ '馬', '嗎', '瑪', '碼', '螞', '獁' ],
'尼ni2': [ '呢', '泥', '怩', '坭' ],
'色se4': [ '色', '铯', '銫' ],
'巴ba1': [ '吧', '疤', '芭', '笆', '粑' ],
'车che1': [ '车', '砗' ],
'車che1': [ '車', '硨' ],
'匕bi3': [ '比', '匕' ],
'比bi3': [ '比', '吡', '妣', '秕' ],
'比bi4': [ '比', '毕', '毙', '陛', '庇', '跸', '毖', '哔', '狴', '荜', '筚' ],
'立li4': [ '立', '粒', '笠', '莅', '蒞' ],
'青qing1': [ '清', '青', '蜻', '鲭', '鯖' ],
'工gong1': [ '工', '功', '攻' ],
'风feng1': [ '风', '疯', '枫' ],
'風feng1': [ '風', '瘋', '楓' ],
'克ke4': [ '剋', '氪' ],
'至zhi4': [ '至', '致', '窒', '蛭', '桎', '郅', '轾', '輊' ],
'表biao3': [ '錶', '婊', '裱' ],
'勿wu4': [ '物', '芴' ],
'林lin2': [ '林', '淋', '琳', '霖', '啉' ],
'干gan4': [ '干', '幹', '旰' ],
'兵bing1': [ '兵', '槟' ],
'非fei1': [ '非', '菲', '啡', '绯', '緋', '扉', '霏', '鲱', '鯡' ],
'目mu4': [ '目', '睦', '苜', '钼', '鉬' ],
'石shi2': [ '石', '炻', '祏' ],
'士shi4': [ '士', '仕' ],
'火huo3': [ '火', '伙' ],
'言yan2': [ '言', '檐' ],
'条tiao2': [ '條', '鲦' ],
'离li2': [ '離', '璃', '篱', '漓', '缡', '縭' ],
'黑hei1': [ '黑', '嘿' ],
'成cheng2': [ '城', '诚', '誠', '盛', '晟', '铖', '鋮', '郕' ],
'音yin1': [ '音', '喑' ],
'合he2': [ '閤', '盒', '颌', '頜', '郃', '饸', '餄' ],
'合ge2': [ '閤', '蛤' ],
'杀sha1': [ '殺', '刹', '铩' ],
'冈gang1': [ '刚', '钢', '纲' ],
'岡gang1': [ '剛', '鋼', '綱' ],
'仑lun2': [ '论', '伦', '轮', '沦', '纶', '抡', '囵' ],
'侖lun2': [ '論', '倫', '輪', '崙', '淪', '綸', '掄', '圇' ],
'乂yi4': [ '义', '议', '艾', '刈' ],
'八ba1': [ '八', '叭', '扒' ],
'母mu3': [ '母', '姆', '拇' ],
'及ji2': [ '极', '级', '級', '汲', '笈', '岌', '芨' ],
'亟ji2': [ '極', '殛' ],
'㐬liu2': [ '流', '琉', '硫' ],
'京jing1': [ '惊', '鲸', '鯨' ],
'正zheng4': [ '政', '证', '怔', '症' ],
'戉yue4': [ '越', '钺', '鉞' ],
'阿a1': [ '啊', '锕', '錒' ],
'令ling3': [ '领', '領', '岭' ],
'衣yi1': [ '衣', '依', '铱', '銥' ],
'衣yi4': [ '衣', '裔' ],
'周zhou1': [ '週', '啁' ],
'龙long2': [ '龙', '笼', '胧', '咙', '聋', '珑', '泷', '茏', '砻', '眬', '栊' ],
'龍long2': [ '龍', '籠', '朧', '嚨', '聾', '瓏', '瀧', '蘢', '礱', '矓', '櫳' ],
'礻shi4': [ '视', '視' ],
'介jie4': [ '界', '芥', '疥', '蚧' ],
'氐di3': [ '底', '抵', '邸', '砥', '诋', '詆', '柢', '骶', '坻' ],
'昜yang2': [ '陽', '楊', '揚', '煬', '瘍', '颺' ],
'台tai2': [ '颱', '抬', '苔', '邰', '跆', '炱', '骀', '駘' ],
'云yun2': [ '雲', '芸', '纭', '紜', '耘' ],
'木mu4': [ '木', '沐' ],
'毛mao2': [ '毛', '髦', '牦', '氂', '旄' ],
'尌shu4': [ '樹', '澍' ],
'亭ting2': [ '停', '婷', '葶' ],
'丽li2': [ '麗', '骊', '鹂' ],
'丽li4': [ '麗', '俪', '郦' ],
'勹bao1': [ '包', '胞', '苞', '龅', '齙', '孢' ],
'首shou3': [ '首', '艏' ],
'志zhi4': [ '誌', '痣' ],
'雚guan4': [ '觀', '灌', '罐', '鹳', '鸛' ],
'业ye4': [ '業', '邺' ],
'田tian2': [ '田', '钿', '鈿', '畋' ],
'哥ge1': [ '哥', '歌' ],
'囗wei2': [ '围', '圍', '涠', '潿' ],
'韦wei2': [ '围', '韦', '违', '闱', '帏', '涠' ],
'韋wei2': [ '圍', '韋', '違', '闈', '幃', '潿' ],
'胡hu2': [ '鬍', '湖', '糊', '餬', '蝴', '葫', '瑚', '鹕', '鶘', '猢', '煳', '醐' ],
'耶ye2': [ '爺', '揶' ],
'务wu4': [ '務', '雾' ],
'娄lou2': [ '楼', '喽', '髅', '偻', '蝼', '蒌', '耧' ],
'婁lou2': [ '樓', '嘍', '髏', '僂', '螻', '蔞', '耬' ],
'朋peng2': [ '朋', '鹏', '鵬', '棚', '堋', '硼' ],
'曼man4': [ '慢', '漫', '蔓', '幔', '谩', '謾', '熳', '缦', '縵', '墁' ],
'皮pi2': [ '皮', '疲', '陂' ],
'土tu3': [ '土', '吐', '钍', '釷' ],
'畐fu2': [ '福', '幅', '蝠', '辐', '輻', '匐', '褔' ],
'支zhi1': [ '支', '枝', '吱', '肢' ],
'闌lan2': [ '蘭', '攔', '欄', '瀾', '斕', '讕' ],
'斿you2': [ '游', '遊', '蝣' ],
'术shu4': [ '術', '述', '沭' ],
'邦bang1': [ '帮', '梆' ],
'氐di1': [ '低', '羝' ],
'路lu4': [ '露', '璐', '潞', '鹭', '鷺' ],
'卩jie2': [ '節', '癤' ],
'角jue2': [ '角', '桷', '觖' ],
'叚jia3': [ '假', '嘏' ],
'余yu2': [ '餘', '畬' ],
'中zhong1': [ '钟', '忠', '衷', '盅' ],
'豊li3': [ '禮', '澧', '醴' ],
'玉yu4': [ '玉', '钰', '鈺' ],
'旡ji4': [ '既', '暨' ],
'彐ji4': [ '既', '暨', '鲫', '鯽' ],
'止zhi3': [ '止', '征', '址', '趾', '芷', '祉', '阯' ],
'广guang3': [ '广', '廣', '犷', '獷' ],
'米mi3': [ '米', '敉' ],
'呈cheng2': [ '程', '裎', '酲' ],
'户hu4': [ '护', '户', '沪', '滬', '扈', '戽' ],
'太tai4': [ '态', '汰', '肽', '钛', '鈦', '酞' ],
'耳er3': [ '耳', '饵', '餌', '洱', '珥' ],
'昏hun1': [ '婚', '阍', '閽' ],
'州zhou1': [ '州', '洲' ],
'刀dao1': [ '刀', '叨' ],
'求qiu2': [ '球', '裘', '俅', '逑', '赇', '賕' ],
'列lie4': [ '烈', '裂', '洌', '冽', '趔' ],
'堇jin3': [ '僅', '谨', '謹', '瑾', '馑', '饉', '槿' ],
'羊yang2': [ '洋', '羊', '佯', '烊', '蛘', '徉' ],
'弗fu2': [ '佛', '彿', '拂', '砩', '怫', '氟', '茀', '绋', '紼' ],
'臼jiu4': [ '舊', '舅', '臼', '桕' ],
'松song1': [ '鬆', '淞', '凇', '崧', '菘' ],
'式shi4': [ '试', '試', '轼', '軾', '拭', '弑', '弒' ],
'登deng1': [ '燈', '蹬', '簦', '噔' ],
'番fan1': [ '翻', '幡' ],
'必bi4': [ '秘', '毖', '邲', '閟', '铋', '鉍' ],
'禺yu4': [ '遇', '寓' ],
'鱼yu2': [ '鱼', '渔' ],
'魚yu2': [ '魚', '漁' ],
'乡xiang1': [ '鄉', '芗' ],
'竟jing4': [ '境', '镜', '鏡', '獍' ],
'乇tuo1': [ '托', '託' ],
'秋qiu1': [ '鞦', '鳅', '鰍', '楸' ],
'申shen1': [ '伸', '绅', '紳', '呻', '砷' ],
'齐qi2': [ '齐', '脐', '蛴', '荠' ],
'齊qi2': [ '齊', '臍', '蠐', '薺' ],
'亢kang4': [ '抗', '炕', '伉', '钪', '鈧' ],
'元yuan2': [ '园', '沅', '鼋', '黿', '芫' ],
'袁yuan2': [ '園', '猿', '辕', '轅' ],
'朱zhu1': [ '硃', '珠', '株', '蛛', '诛', '誅', '侏', '铢', '銖', '茱', '洙', '邾' ],
'昷wen1': [ '温', '瘟' ],
'奂huan4': [ '换', '唤', '焕', '痪', '涣' ],
'奐huan4': [ '換', '喚', '煥', '瘓', '渙' ],
'川chuan1': [ '川', '氚' ],
'乃nai3': [ '奶', '氖', '艿' ],
'扁pian1': [ '篇', '偏', '萹', '翩' ],
'孰shu2': [ '熟', '塾' ],
'代dai4': [ '袋', '黛', '贷', '貸', '岱', '玳' ],
'直zhi2': [ '值', '植', '殖', '埴' ],
'胃wei4': [ '谓', '謂', '渭', '猬', '蝟' ],
'耤ji2': [ '藉', '籍' ],
'廷ting2': [ '庭', '霆', '蜓', '莛' ],
'由you2': [ '油', '邮', '铀', '鈾', '蚰' ],
'般pan2': [ '盤', '磐' ],
'凵qu1': [ '曲', '蛐' ],
'牙ya2': [ '牙', '伢', '芽', '琊', '蚜' ],
'正zheng1': [ '征', '怔', '症', '钲', '鉦' ],
'付fu4': [ '附', '咐', '驸', '駙', '鲋', '鮒', '祔' ],
'夅jiang4': [ '降', '绛', '絳', '洚' ],
'乍zha4': [ '炸', '咋', '诈', '詐', '蚱' ],
'卂xun4': [ '迅', '讯', '訊', '汛' ],
'卦gua4': [ '掛', '褂' ],
'采cai3': [ '彩', '踩', '睬' ],
'鼓gu3': [ '鼓', '瞽', '臌' ],
'匈xiong1': [ '胸', '洶' ],
'才cai2': [ '财', '財', '材' ],
'受shou4': [ '授', '绶', '綬' ],
'蒦huo4': [ '穫', '蠖', '镬', '鑊' ],
'赫he4': [ '嚇', '赫' ],
'鸟niao3': [ '鸟', '茑' ],
'鳥niao3': [ '鳥', '蔦' ],
'分fen1': [ '纷', '紛', '芬', '吩', '氛', '酚', '玢' ],
'贝bei4': [ '贝', '狈', '钡' ],
'貝bei4': [ '貝', '狽', '鋇' ],
'彔lu4': [ '錄', '祿', '淥' ],
'皆jie1': [ '階', '楷', '喈' ],
'奇qi2': [ '骑', '騎', '崎', '琦', '锜', '錡' ],
'尤you2': [ '犹', '鱿', '魷', '疣' ],
'乔qiao2': [ '桥', '侨', '荞' ],
'喬qiao2': [ '橋', '僑', '蕎' ],
'平ping2': [ '评', '評', '苹', '坪', '鲆', '鮃', '枰' ],
'尸shi1': [ '尸', '屍' ],
'曾zeng1': [ '增', '憎', '罾', '缯', '繒' ],
'睪yi4': [ '譯', '驛', '繹', '嶧', '懌' ],
'辰chen2': [ '晨', '辰', '宸' ],
'雍yong1': [ '擁', '臃', '饔' ],
'刑xing2': [ '型', '硎' ],
'衮gun3': [ '滚', '磙' ],
'冬dong1': [ '鼕', '咚', '氡' ],
'甘gan1': [ '甘', '柑', '苷', '泔', '疳', '坩' ],
'半ban4': [ '伴', '绊', '絆', '拌' ],
'鬲ge2': [ '隔', '嗝', '镉', '鎘', '膈', '鬲' ],
'来lai2': [ '莱', '涞', '徕', '崃' ],
'來lai2': [ '萊', '淶', '徠', '崍' ],
'贯guan4': [ '惯', '掼' ],
'貫guan4': [ '慣', '摜' ],
'臿cha1': [ '插', '锸', '鍤' ],
'区ou1': [ '欧', '鸥', '殴', '沤', '讴', '瓯' ],
'區ou1': [ '歐', '鷗', '毆', '漚', '謳', '甌' ],
'意yi4': [ '憶', '億', '臆', '薏', '癔' ],
'朵duo3': [ '躲', '垛', '哚' ],
'召shao4': [ '绍', '紹', '邵', '劭' ],
'敞chang3': [ '廠', '氅' ],
'監jian4': [ '艦', '檻' ],
'臽xian4': [ '陷', '馅', '餡' ],
'罔wang3': [ '網', '惘', '魍', '辋', '輞' ],
'原yuan2': [ '源', '塬', '螈' ],
'票piao4': [ '漂', '骠', '驃', '嘌' ],
'奄yan3': [ '掩', '罨' ],
'岂kai3': [ '凯', '恺', '铠', '闿', '剀' ],
'豈kai3': [ '凱', '愷', '鎧', '闓', '剴' ],
'劦xie2': [ '協', '脅', '勰' ],
'相xiang1': [ '箱', '湘', '厢', '廂', '缃', '緗' ],
'乘sheng4': [ '剩', '嵊' ],
'度du4': [ '渡', '镀', '鍍' ],
'氏shi4': [ '氏', '舐' ],
'氏zhi1': [ '氏', '祗', '胝' ],
'宗zong1': [ '踪', '棕', '综', '綜', '鬃' ],
'犮ba2': [ '拔', '跋', '魃', '茇' ],
'爰yuan2': [ '援', '媛' ],
'朝chao2': [ '潮', '嘲' ],
'孚fu2': [ '浮', '俘', '郛', '莩', '蜉', '桴' ],
'尉wei4': [ '慰', '蔚', '霨' ],
'夗yuan4': [ '怨', '苑' ],
'仓cang1': [ '苍', '舱', '沧', '伧' ],
'倉cang1': [ '蒼', '艙', '滄', '傖' ],
'暴bao4': [ '爆', '瀑' ],
'辛xin1': [ '辛', '莘', '锌', '鋅' ],
'建jian4': [ '健', '键', '鍵', '腱', '毽' ],
'巨ju4': [ '距', '拒', '炬', '钜', '鉅', '苣', '讵', '詎' ],
'勾gou4': [ '构', '购' ],
'冓gou4': [ '構', '購', '媾', '觏', '覯', '遘' ],
'贞zhen1': [ '侦', '桢', '祯' ],
'貞zhen1': [ '偵', '楨', '禎' ],
'帝di4': [ '蒂', '谛', '諦', '缔', '締' ],
'禺ou3': [ '偶', '耦' ],
'吕lu:3': [ '吕', '侣', '铝', '鋁' ],
'丈zhang4': [ '仗', '杖' ],
'利li4': [ '莉', '俐', '痢', '猁' ],
'甬yong3': [ '涌', '踊', '蛹', '俑' ],
'昌chang1': [ '昌', '娼', '猖', '菖', '阊', '閶', '鲳', '鯧' ],
'悤cong1': [ '聰', '蔥', '骢', '驄' ],
'丁ding1': [ '盯', '钉', '釘', '叮', '仃', '玎', '疔' ],
'令ling2': [ '零','玲','铃','鈴','龄','齡','伶','翎','聆','羚','苓','蛉','呤','泠','囹','瓴','鸰','鴒','舲' ],
'冒mao4': [ '帽', '瑁' ],
'保bao3': [ '堡', '葆', '褓' ],
'夌ling2': [ '凌', '陵', '菱', '绫', '綾' ],
'史shi3': [ '驶', '駛' ],
'弟di4': [ '递', '娣', '睇' ],
'农nong2': [ '浓', '侬', '哝', '脓', '秾' ],
'農nong2': [ '濃', '儂', '噥', '膿', '穠' ],
'争zheng1': [ '睁', '挣', '铮', '錚', '筝', '狰', '峥' ],
'爭zheng1': [ '睜', '掙', '箏', '猙', '崢' ],
'良liang2': [ '粮', '踉' ],
'灰hui1': [ '恢', '诙', '詼', '咴' ],
'般ban1': [ '搬', '瘢' ],
'夫fu2': [ '扶', '芙', '蚨' ],
'宛wan3': [ '碗', '婉', '惋', '畹', '琬', '菀' ],
'匋tao2': [ '陶', '淘', '萄', '啕' ],
'菐pu2': [ '僕', '璞' ],
'具ju4': [ '惧', '俱', '飓', '颶' ],
'旋xuan2': [ '璇', '漩' ],
'苗miao2': [ '描', '瞄', '鹋', '鶓' ],
'勾gou1': [ '沟', '钩' ],
'逢feng2': [ '缝', '縫' ],
'连lian2': [ '莲', '涟', '裢', '鲢' ],
'連lian2': [ '蓮', '漣', '褳', '鰱' ],
'畏wei4': [ '喂', '餵' ],
'旁pang2': [ '膀', '螃' ],
'虫chong2': [ '虫', '蟲' ],
'辡bian4': [ '辩', '辯', '辨', '辫', '辮' ],
'戋jian1': [ '浅', '笺', '篯', '戋' ],
'戔jian1': [ '淺', '箋', '籛', '戔' ],
'当dang4': [ '挡', '档' ],
'當dang4': [ '擋', '檔' ],
'瓜gua1': [ '瓜', '胍' ],
'希xi1': [ '稀', '唏', '浠', '欷', '烯', '豨' ],
'彡shan1': [ '衫', '杉', '钐', '釤', '彡' ],
'折zhe2': [ '哲', '蜇' ],
'㢆chan2': [ '缠', '廛' ],
'南nan2': [ '喃', '楠' ],
'豆dou4': [ '豆', '逗', '痘' ],
'莫mo4': [ '漠', '寞', '蓦', '镆', '鏌', '貘', '瘼' ],
'名ming2': [ '铭', '銘', '茗', '眳' ],
'兰lan2': [ '拦', '栏' ],
'郎lang2': [ '廊', '瑯', '螂', '榔', '鎯' ],
'复fu4': [ '腹', '馥', '蝮', '複', '鳆', '鰒' ],
'夕xi1': [ '夕', '汐', '穸', '矽' ],
'末mo4': [ '抹', '沫', '茉', '秣' ],
'盧lu2': [ '爐', '蘆', '廬', '顱', '臚', '鱸', '鸕', '艫', '瀘', '轤', '櫨', '壚' ],
'彌mi2': [ '瀰', '獼' ],
'毌guan4': [ '贯', '貫' ],
'夷yi2': [ '姨', '咦', '胰', '痍', '荑' ],
'俞yu2': [ '愉', '瑜', '逾', '榆', '渝', '揄', '觎', '覦', '嵛', '窬', '蝓', '踰', '隃' ],
'免mian3': [ '勉', '冕', '娩' ],
'呙guo1': [ '锅', '涡', '埚' ],
'咼guo1': [ '鍋', '渦', '堝' ],
'疌jie2': [ '捷', '睫', '婕' ],
'矛mao2': [ '矛', '茅', '蟊', '蝥', '髳' ],
'区qu1': [ '驱', '躯', '岖' ],
'區qu1': [ '驅', '軀', '嶇' ],
'崔cui1': [ '催', '摧' ],
'厓ya2': [ '崖', '涯', '睚' ],
'沙sha1': [ '莎', '鲨', '鯊', '裟', '痧' ],
'欠qian4': [ '歉', '欠', '嵌', '芡' ],
'羲xi1': [ '犧', '曦' ],
'兹zi1': [ '滋', '孳', '嵫' ],
'妻qi1': [ '凄', '淒', '棲', '萋' ],
'千qian1': [ '迁', '仟', '阡', '芊', '钎', '釺', '扦' ],
'禺yu2': [ '愚', '隅' ],
'鹿lu4': [ '鹿', '漉', '辘', '轆', '麓', '簏' ],
'弓gong1': [ '弓', '躬' ],
'旬xun2': [ '询', '詢', '荀', '洵', '峋', '恂', '郇' ],
'丙bing3': [ '柄', '炳', '邴' ],
'皇huang2': [ '惶', '煌', '凰', '蝗', '徨', '隍', '湟', '遑', '篁', '锽', '鍠' ],
'布bu4': [ '怖', '钸', '鈽' ],
'斯si1': [ '撕', '嘶', '厮', '廝', '澌' ],
'府fu3': [ '腐', '俯', '腑' ],
'夫fu1': [ '肤', '趺', '呋', '麸', '麩' ],
'因yin1': [ '姻', '茵', '氤', '洇', '骃', '駰' ],
'奚xi1': [ '溪', '谿', '蹊' ],
'丩jiu1': [ '纠', '糾', '赳' ],
'属zhu3': [ '嘱', '瞩' ],
'屬zhu3': [ '囑', '矚' ],
'廉lian2': [ '簾', '镰', '鐮', '濂', '蠊' ],
'侯hou2': [ '喉', '睺', '猴', '糇', '餱', '篌' ],
'敝bi4': [ '幣', '蔽', '斃', '弊' ],
'录lu4': [ '禄', '碌', '渌', '逯', '箓' ],
'华hua2': [ '哗', '骅', '铧' ],
'華hua2': [ '嘩', '驊', '鏵' ],
'果guo3': [ '裹', '猓', '馃', '餜', '蜾' ],
'夜ye4': [ '液', '腋', '掖' ],
'占zhan1': [ '沾', '粘', '毡' ],
'尊zun1': [ '遵', '樽', '鳟', '鱒' ],
'其qi2': [ '棋', '琪', '祺', '淇', '麒', '綦', '骐', '騏', '萁', '蜞' ],
'秀xiu4': [ '绣', '锈', '銹' ],
'唐tang2': [ '糖', '塘', '搪', '瑭', '醣', '溏', '螗' ],
'会hui4': [ '绘', '荟', '烩' ],
'會hui4': [ '繪', '薈', '燴' ],
'厉li4': [ '励', '蛎', '砺', '粝' ],
'厲li4': [ '勵', '蠣', '礪', '糲' ],
'乌wu1': [ '呜', '邬', '钨' ],
'烏wu1': [ '嗚', '鄔', '鎢' ],
'亥hai4': [ '骇', '駭', '氦' ],
'甬tong3': [ '桶', '捅' ],
'龠yue4': [ '鑰', '瀹', '龠' ],
'卑bei1': [ '碑', '鹎', '鵯' ],
'隶li4': [ '隶', '隸' ],
'包bao1': [ '胞', '苞', '龅', '齙', '孢' ],
'丨shu4': [ '竖', '翛' ],
'叔shu1': [ '淑', '菽' ],
'夹jia2': [ '颊', '郏', '荚', '蛱', '铗' ],
'夾jia2': [ '頰', '郟', '莢', '蛺', '鋏' ],
'丘qiu1': [ '邱', '蚯' ],
'句gou1': [ '鉤', '佝', '枸' ],
'交jiao1': [ '郊', '胶', '蛟', '跤', '姣', '鲛', '鮫', '茭' ],
'甫fu3': [ '辅', '輔', '脯', '黼', '郙' ],
'夏xia4': [ '厦', '廈' ],
'咢e4': [ '愕', '鄂', '萼', '鳄', '颚', '顎', '锷', '鍔', '鹗', '鶚', '谔', '諤', '腭', '齶' ],
'罗luo2': [ '逻', '萝', '锣', '箩', '椤', '猡' ],
'羅luo2': [ '邏', '蘿', '鑼', '籮', '欏', '玀' ],
'析xi1': [ '晰', '皙', '淅', '蜥', '菥' ],
'容rong2': [ '蓉', '溶', '熔', '榕', '镕', '鎔' ],
'益yi4': [ '溢', '谥', '謚', '缢', '縊', '镒', '鎰' ],
'粲can4': [ '燦', '璨' ],
'坒bi4': [ '陛', '狴' ],
'熏xun1': [ '勳', '薰', '醺', '獯', '曛', '纁' ],
'官guan1': [ '棺', '倌' ],
'敖ao2': [ '熬', '鳌', '鰲', '嗷', '遨', '獒', '螯', '聱', '廒' ],
'奄yan1': [ '淹', '阉', '閹', '腌', '醃', '崦' ],
'考kao3': [ '烤', '拷', '栲' ],
'辟pi4': [ '闢', '譬', '僻', '甓' ],
'迷mi2': [ '谜', '謎', '醚' ],
'普pu3': [ '谱', '譜', '镨', '鐠' ],
'婴ying1': [ '樱', '鹦', '嘤', '缨', '撄', '璎' ],
'嬰ying1': [ '櫻', '鸚', '嚶', '纓', '攖', '瓔' ],
'凶xiong1': [ '汹', '匈' ],
'蒙meng2': [ '朦', '檬', '矇', '艨', '礞' ],
'頻pin2': [ '蘋', '顰' ],
'夹jia1': [ '挟', '浃' ],
'夾jia1': [ '挾', '浹' ],
'留liu2': [ '榴', '瘤', '镏', '鎦', '馏', '餾', '骝', '騮' ],
'召zhao4': [ '诏', '詔' ],
'柔rou2': [ '揉', '蹂', '鞣', '糅' ],
'审shen3': [ '婶', '渖' ],
'審shen3': [ '嬸', '瀋' ],
'臭xiu4': [ '嗅', '溴' ],
'宣xuan1': [ '喧', '諠', '暄', '煊', '萱', '揎' ],
'亚ya4': [ '娅', '垭', '氩' ],
'亞ya4': [ '婭', '埡', '氬' ],
'右you4': [ '佑', '祐' ],
'禽qin2': [ '擒', '噙', '檎' ],
'㐱zhen3': [ '诊', '診', '疹', '畛', '轸', '軫' ],
'疾ji2': [ '嫉', '蒺' ],
'星xing1': [ '腥', '猩', '惺' ],
'堂tang2': [ '膛', '螳', '樘' ],
'奥ao4': [ '澳', '懊' ],
'戎rong2': [ '绒', '絨' ],
'蔑mie4': [ '衊', '蠛' ],
'息xi1': [ '熄', '螅' ],
'犬quan3': [ '犬', '畎' ],
'永yong3': [ '泳', '咏', '詠' ],
'敫jiao3': [ '缴', '繳', '徼' ],
'庸yong1': [ '傭', '慵', '镛', '鏞', '墉' ],
'宾bin1': [ '滨', '缤', '傧', '镔' ],
'賓bin1': [ '濱', '繽', '鑌' ],
'將jiang4': [ '漿', '醬' ],
'伐fa2': [ '阀', '閥', '筏' ],
'崩beng1': [ '繃', '嘣' ],
'虚xu1': [ '嘘', '墟' ],
'阑lan2': [ '澜', '斓', '谰' ],
'厄e4': [ '呃', '扼', '轭', '軛', '阨' ],
'厨chu2': [ '橱', '蹰' ],
'廚chu2': [ '櫥', '躕' ],
'亦yi4': [ '奕', '弈' ],
'吾wu2': [ '唔', '梧', '鼯' ],
'段duan4': [ '缎', '緞', '锻', '鍛', '椴', '煅' ],
'聶nie4': [ '聶', '躡', '囁', '鑷' ],
'眇miao3': [ '渺', '缈', '緲' ],
'詹zhan1': [ '瞻', '谵', '譫' ],
'襄xiang1': [ '镶', '鑲', '骧', '驤' ],
'旱han4': [ '悍', '捍', '焊', '銲' ],
'览lan3': [ '揽', '缆', '榄' ],
'覽lan3': [ '攬', '纜', '欖' ],
'康kang1': [ '慷', '糠' ],
'垂chui2': [ '锤', '錘', '捶', '陲', '棰', '箠' ],
'宁ning2': [ '拧', '狞', '咛', '柠' ],
'寧ning2': [ '擰', '獰', '嚀', '檸' ],
'寧ning4': [ '擰', '濘' ],
'虎hu3': [ '唬', '琥' ],
'豪hao2': [ '嚎', '壕', '濠', '蠔' ],
'解xie4': [ '蟹', '懈', '邂', '獬', '廨' ],
'弟ti4': [ '涕', '剃', '悌' ],
'蚩chi1': [ '嗤', '媸' ],
'闲xian2': [ '娴', '痫', '鹇' ],
'閑xian2': [ '嫻', '鷴' ],
'曳ye4': [ '拽', '曳' ],
'啇di2': [ '嘀', '嫡', '镝', '鏑' ],
'查zha1': [ '喳', '渣', '楂', '揸' ],
'霸ba4': [ '壩', '灞' ],
'圭gui1': [ '闺', '閨', '圭', '硅', '鲑', '鮭', '邽' ],
'離li2': [ '籬', '灕' ],
'牟mou2': [ '眸', '蛑', '侔' ],
'焦jiao1': [ '礁', '蕉', '鹪', '鷦', '僬', '蟭' ],
'忽hu1': [ '惚', '唿' ],
'加jia1': [ '茄', '迦', '伽', '枷', '袈', '跏', '笳', '珈', '痂' ],
'章zhang1': [ '璋', '彰', '樟', '漳', '蟑', '鄣', '獐', '嫜' ],
'巫wu1': [ '诬', '誣' ],
'遣qian3': [ '谴', '譴', '缱', '繾' ],
'卢lu2': [ '颅', '胪', '鲈', '鸬', '舻', '泸', '轳', '栌', '垆' ],
'委wei1': [ '萎', '逶' ],
'委wei3': [ '萎', '诿', '諉', '痿' ],
'焉yan1': [ '嫣', '鄢' ],
'曹cao2': [ '槽', '嘈', '漕', '艚', '螬' ],
'匡kuang1': [ '筐', '哐', '诓', '誆' ],
'退tui4': [ '褪', '煺' ],
'劳lao2': [ '唠', '崂', '痨' ],
'劳lao4': [ '唠', '涝' ],
'勞lao2': [ '嘮', '嶗', '癆' ],
'勞lao4': [ '嘮', '澇' ],
'素su4': [ '愫', '嗉', '膆' ],
'安an1': [ '鞍', '氨', '桉' ],
'居ju1': [ '锯', '鋸', '裾', '琚' ],
'市shi4': [ '柿', '铈', '鈰' ],
'伏fu2': [ '袱', '茯' ],
'乚ya4': [ '轧', '軋' ],
'厘li2': [ '釐', '喱' ],
'幺yao1': [ '吆', '幺' ],
'黄huang2': [ '簧', '磺', '璜', '潢', '蟥' ],
'井jing3': [ '阱', '肼' ],
'颠dian1': [ '癫', '巅' ],
'顛dian1': [ '癲', '巔' ],
'历li4': [ '雳', '沥', '枥', '呖', '苈', '疬' ],
'歷li4': [ '靂', '瀝', '櫪', '嚦', '藶', '癧' ],
'眉mei2': [ '湄', '嵋', '楣', '镅', '鎇', '郿' ],
'聂nie4': [ '蹑', '嗫', '镊' ],
'央yang1': [ '鞅', '秧', '殃', '鸯', '鴦', '泱' ],
'巳si4': [ '巳', '祀', '汜' ],
'责ze2': [ '啧', '赜', '帻', '箦' ],
'責ze2': [ '嘖', '賾', '幘', '簀' ],
'今jin1': [ '矜', '衿' ],
'敦dun1': [ '墩', '礅' ],
'彭peng2': [ '膨', '澎', '蟛' ],
'邑yi4': [ '邑', '悒', '挹' ],
'善shan4': [ '膳', '蟮', '缮', '繕', '鳝', '鱔', '鄯' ],
'無wu2': [ '蕪', '廡' ],
'展zhan3': [ '辗', '輾' ],
'卡ka3': [ '咔', '胩' ],
'隹zhui1': [ '锥', '錐', '椎', '骓', '騅', '隹' ],
'刃ren4': [ '韧', '韌', '纫', '紉', '仞', '轫', '軔' ],
'延yan2': [ '蜒', '筵' ],
'武wu3': [ '鹉', '鵡' ],
'署shu3': [ '薯', '曙' ],
'爱ai4': [ '嗳', '暧', '嫒', '瑷' ],
'愛ai4': [ '噯', '曖', '嬡', '璦' ],
'童tong2': [ '瞳', '潼', '僮' ],
'可ke3': [ '轲', '軻', '坷', '岢' ],
'雷lei2': [ '擂', '镭', '鐳', '檑' ],
'㝉zhu4': [ '贮', '伫', '苎' ],
'冀ji4': [ '骥', '驥' ],
'尽jin4': [ '烬', '荩', '赆' ],
'盡jin4': [ '燼', '藎', '贐' ],
'毚chan2': [ '饞', '讒' ],
'全quan2': [ '荃', '痊', '诠', '詮', '铨', '銓', '筌' ],
'遂sui4': [ '隧', '邃', '燧' ],
'惠hui4': [ '蕙', '蟪' ],
'若ruo4': [ '偌', '箬' ],
'弍er4': [ '贰', '貳' ],
'芻chu2': [ '雛', '芻' ],
'悉xi1': [ '蟋', '窸' ],
'庚geng1': [ '赓', '賡' ],
'当dang1': [ '裆', '铛' ],
'當dang1': [ '襠', '鐺' ],
'矍jue2': [ '攫', '钁' ],
'尾wei3': [ '娓', '艉' ],
'赖lai4': [ '籁', '癞', '濑' ],
'賴lai4': [ '籟', '癩', '瀨' ],
'甲jia3': [ '岬', '胛', '钾', '鉀' ],
'敢gan3': [ '橄', '澉' ],
'奇ji1': [ '畸', '犄', '剞' ],
'臾yu2': [ '谀', '諛', '腴', '萸' ],
'冥ming2': [ '瞑', '溟', '暝', '螟' ],
'主zhu3': [ '拄', '麈' ],
'休xiu1': [ '咻', '庥', '鸺', '髹', '貅' ],
'豐feng1': [ '灃', '酆' ],
'波bo1': [ '啵', '菠' ],
'查cha2': [ '碴', '楂', '猹' ],
'猋biao1': [ '飙', '飆' ],
'彦yan4': [ '谚', '諺' ],
'固gu4': [ '锢', '錮', '崮', '痼' ],
'于yu2': [ '盂', '竽' ],
'盍he2': [ '阖', '闔' ],
'匽yan3': [ '偃', '鼴', '郾' ],
'卯mao3': [ '卯', '峁', '铆', '鉚', '昴', '泖', '茆' ],
'殿dian4': [ '澱', '癜' ],
'丝si1': [ '咝', '鸶' ],
'絲si1': [ '噝', '鷥' ],
'单dan1': [ '郸', '殚', '箪', '瘅' ],
'單dan1': [ '鄲', '殫', '簞', '癉' ],
'囊nang2': [ '馕', '饢' ],
'光guang1': [ '咣', '胱', '銧', '桄' ],
'屯tun2': [ '饨', '飩', '囤' ],
'引yin3': [ '蚓', '吲' ],
'從cong1': [ '樅', '蓯' ],
'定ding4': [ '锭', '錠', '碇', '腚', '啶' ],
'戚qi1': [ '嘁', '槭' ],
'卞bian4': [ '汴', '苄', '忭' ],
'垔yin1': [ '湮', '堙' ],
'四si4': [ '泗', '驷', '駟' ],
'商shang1': [ '墒', '熵' ],
'厥jue2': [ '獗', '蹶', '镢', '蕨', '橛', '劂' ],
'丕pi1': [ '坯', '邳' ],
'昆kun1': [ '锟', '錕', '琨', '鲲', '鯤', '醌' ],
'孙sun1': [ '荪', '狲' ],
'孫sun1': [ '蓀', '猻' ],
'阿e1': [ '婀', '屙' ],
'强jiang4': [ '犟', '糨' ],
'麗li4': [ '儷', '酈' ],
'就jiu4': [ '鹫', '鷲', '僦' ],
'告gao4': [ '诰', '誥', '郜', '锆', '鋯' ],
'狂kuang2': [ '诳', '誑' ],
'耆qi2': [ '鳍', '鰭' ],
'咨zi1': [ '谘', '諮' ],
'瞿qu2': [ '衢', '癯' ],
'寻xun2': [ '荨', '浔', '鲟' ],
'尋xun2': [ '蕁', '潯', '鱘' ],
'殸qing4': [ '罄', '磬' ],
'麃biao1': [ '镳', '鑣' ],
'威wei1': [ '崴', '葳' ],
'毕bi4': [ '跸', '哔', '荜', '筚' ],
'畢bi4': [ '蹕', '嗶', '蓽', '篳' ],
'空kong1': [ '崆', '倥', '箜' ],
'午wu3': [ '忤', '迕', '仵' ],
'美mei3': [ '镁', '鎂' ],
'勺shao2': [ '芍', '杓' ],
'易yi4': [ '蜴', '埸' ],
'久jiu3': [ '灸', '玖' ],
'古gu3': [ '诂', '詁', '牯', '罟', '嘏', '钴', '鈷' ],
'晋jin4': [ '缙', '縉' ],
'者zhe3': [ '赭', '锗', '鍺' ],
'矞yu4': [ '鹬', '鷸', '遹' ],
'颉xie2': [ '撷', '缬' ],
'頡xie2': [ '擷', '纈' ],
'尚shang4': [ '绱', '緔' ],
'荣rong2': [ '嵘', '蝾' ],
'榮rong2': [ '嶸', '蠑' ],
'麗li2': [ '驪', '鸝' ],
'耒lei3': [ '诔', '誄', '耒' ],
'朔shuo4': [ '槊', '搠' ],
'含han2': [ '焓', '晗' ],
'甹ping1': [ '娉', '俜' ],
'丸wan2': [ '纨', '紈', '芄' ],
'强qiang3': [ '襁', '镪', '鏹' ],
'国guo2': [ '掴', '帼' ],
'國guo2': [ '摑', '幗' ],
'会kuai4': [ '侩', '脍', '狯', '哙', '浍', '郐' ],
'會kuai4': [ '儈', '膾', '獪', '噲', '澮', '鄶' ],
'丐gai4': [ '钙', '鈣' ],
'屯zhun1': [ '肫', '窀' ],
'各ge4': [ '硌', '铬', '鉻' ],
'思si1': [ '锶', '鍶', '缌', '緦' ],
'艮gen4': [ '艮', '茛' ],
'奔ben1': [ '锛', '錛' ],
'兔tu4': [ '菟', '堍' ],
'了liao3': [ '钌', '釕' ],
'霍huo4': [ '嚯', '藿' ],
'累lei2': [ '嫘', '缧', '縲' ],
'族zu2': [ '镞', '鏃' ],
'凡fan2': [ '矾', '钒', '釩' ],
'不bu4': [ '钚', '鈈' ],
'哀ai1': [ '锿', '鎄' ],
'臬nie4': [ '镍', '鎳' ],
'奴nu2': [ '驽', '駑', '孥' ],
'耑zhuan1': [ '颛', '顓' ],
'东dong1': [ '鸫', '岽' ],
'東dong1': [ '鶇', '崠' ],
'兼jian1': [ '缣', '縑', '鹣', '鶼', '蒹' ],
'酋qiu2': [ '遒', '蝤' ],
'兀wu4': [ '杌', '靰' ],
'秦qin2': [ '螓', '嗪' ],
'局ju2': [ '锔', '鋦' ],
'雪xue3': [ '鳕', '鱈' ],
'甚shen4': [ '葚', '椹' ],
'时shi2': [ '莳', '埘', '鲥' ],
'時shi2': [ '蒔', '塒', '鰣' ],
'猪zhu1': [ '橥', '潴' ],
'豬zhu1': [ '櫫', '瀦' ],
'陟zhi4': [ '骘', '騭' ],
'冖mi4': [ '幂', '冪' ],
'拿na2': [ '镎', '鎿' ],
'便bian4': [ '缏', '緶' ],
'丏mian3': [ '眄', '沔' ],
'世shi4': [ '贳', '貰' ],
'它ta1': [ '铊', '鉈' ],
'扇shan4': [ '骟', '騸' ],
'旋xuan4': [ '镟', '鏇' ],
'家jia1': [ '镓', '鎵' ],
'有you3': [ '铕', '銪' ]};